'use strict';

import lenis from './modules/lenis.mjs';
import scrollReveal from "./modules/scroll-reveal.mjs";
import header from "./modules/header.mjs"
import anchor from "./modules/anchor.mjs";
import parallax from "./modules/parallax.mjs";
import toTop from "./modules/to-top.mjs";

const init = () => {
    lenis.init();
    scrollReveal.init();
    header.init();
    anchor.init();
    parallax.init();
    toTop.init();
}

const scrollToTop = () => {
    lenis.scrollToTop();
}

export default {init, scrollToTop}
